import React, { useEffect, useState } from "react";
import PrivateLayout from "../../layouts/privateLayout";
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  listItemSecondaryActionClasses,
  Stack,
  Tab,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import BasicBreadcrumbs from "../../components/breadcrumb";

import toast from "react-hot-toast";
import FormEmployee from "./formCampaign1";
import EmployeeList from "./employeeList";
import DetailsCampaignForm from "./detailsCampaignForm";
import { useLocation, useParams, Link as RouterLink, useNavigate } from "react-router-dom";
import ScoreList from "./scoreList";
import ErrorAlert from "../../helper/errorAlert";
import dayjs from "dayjs";
import api from "../../helper/baseApi";
import { useApiClient } from "../../context/ApiClientContext";
import ViewDetails from "./viewDetails";
import ActivityListing from "../../components/activityListing";
// import FormEmployee from "./formEmployee"

export const DataContext = React.createContext();

const CampaignContainer = () => {
  const { id } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPage, setTotalPage] = React.useState();
  const [pageSize, setPageSize] = React.useState();
  const [filteredDataList, setFilteredDataList] = React.useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const [inputForm, setInputForm] = useState([]);
  const [isLoading, setLoading] = React.useState(false);
  const {
    apiUrls: { mobileApiUrl },
  } = useApiClient();
  if (typeof id === "object" && id !== null) {
    console.log("ID/ is an object, keys:", Object.keys(id));
    // console.log("ID object content:", id);
  }

  const activities = {
    today: [
      {
        email: "yp.loo@gosumgroup.com",
        action: "submit mission",
        time: "2 hours ago",
      },
      {
        email: "yp.loo@gosumgroup.com",
        action: "open the mission",
        time: "6 hours ago",
      },
      {
        email: "naja@gosumgroup.com",
        action: "liked the mission",
        time: "8 hours ago",
      },
      {
        email: "nurin@gosumgroup.com",
        action: "liked the mission",
        time: "8 hours ago",
      },
      {
        email: "naja@gosumgroup.com",
        action: "open the mission",
        time: "12 hours ago",
        image: "https://picsum.photos/60/40?1",
      },
    ],
    thisWeek: [
      {
        email: "zixin.chen@gosumgroup.com",
        action: "assign the mission to nurin@gosumgroup.com",
        time: "4 days ago",
        image: "https://picsum.photos/60/40?3",
      },
      {
        email: "zixin.chen@gosumgroup.com",
        action: "assign the mission to naja@gosumgroup.com",
        time: "4 days ago",
        image: "https://picsum.photos/60/40?3",
      },
      {
        email: "zixin.chen@gosumgroup.com",
        action: "assign the mission to nurin@gosumgroup.com",
        time: "5 days ago",
        image: "https://picsum.photos/60/40?4",
      },
      {
        email: "zixin.chen@gosumgroup.com",
        action: "assign the mission to naja@gosumgroup.com",
        time: "5 days ago",
        image: "https://picsum.photos/60/40?4",
      },
      {
        email: "zixin.chen@gosumgroup.com",
        action: "create this mission",
        time: "5 days ago",
        image: "https://picsum.photos/60/40?4",
      },
    ],
  };

  useEffect(() => {
    if (id) {
      fetchData(id);
    } else {
      setLoading(false);
    }
  }, [id]);


  const fetchData = async (page) => {
    try {
      setLoading(true);
      // 🔹 Get employeeId
      const employeeId = localStorage.getItem("employeeId");

      // 🔹 Use baseApi with params
      const response = await api.get(`${mobileApiUrl}reward/reward-details-portal?rewardId=${id}`, {
    //   params: {
    //     employeeId,
    //     rewardId: actualId,
    //   },
    });

      if (response.data) {
        const resData = response.data.data;

        setInputForm({
          name: resData.name || "",
          description: resData.description || "",
          startDate: resData.startDate
            ? dayjs(resData.startDate).format("YYYY-MM-DD")
            : "",
          endDate: resData.endDate
            ? dayjs(resData.endDate).format("YYYY-MM-DD")
            : "",
          PrizeQty: resData.PrizeQty || "",
          entitlementPoint: resData.entitlementPoint || "",
          status: resData.status || "",
          createdBy: resData.createdBy || "",
          createdDate: resData.createdDate
            ? dayjs(resData.createdDate).format("YYYY-MM-DD")
            : "",
        });
      }
    } catch (error) {
      ErrorAlert(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PrivateLayout>
      <Box sx={{ mx: "40px", mt: 5, mb: 5 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
            // mb: 3,
          }}
        >
          <Box display="flex" justifyContent="start" alignItems="center">
            <BasicBreadcrumbs
              first={
                <Link component={RouterLink} to="/campaign" underline="hover" color="primary.main">
                  Campaign
                </Link>
              }
              second="View" />
            <Box sx={{ display: "flex" }}></Box>
          </Box>
        </Box>
        <Grid container spacing={8} mb={3}>
          {/* <Grid item mt={1} size={{ xs: 12, md: 5 }}>
            <ActivityListing activities={activities} />
          </Grid> */}
          <Grid item size={{ xs: 12}}>
            <Box display="flex" justifyContent="flex-end" backgroundColor="white" p={2} borderRadius={2} boxShadow={3} mt={2}>

              <ViewDetails id={id} campaignList={inputForm} />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </PrivateLayout>
  );
};

export default CampaignContainer;
